// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__NR2uB","box":"WorkspacesBox_box__3Epew","node":"WorkspacesBox_node__12U-G"};